import React from 'react';
import translator from "../translations/drupalTranslator";

const FreeCancellationInfo = () => (
  <div className="free-cancellation-info">
    {translator.translate('Free cancellation')}
  </div>
);

export default FreeCancellationInfo;
